import apiHeader from '@/helpers/apiHeader';

const menuService = {
  getManageMenu() {
    return apiHeader.get('general-setting/app-configuration/manage-menu');
  },
  updateManageMenuStatus(code, payload) {
    return apiHeader.patch(`general-setting/app-configuration/${code}`, { data: payload });
  },
};

export default menuService;
